import axios from "axios";
import { urlEmpresas, urlPessoas } from "../../../../../constants/endpoints";
import { getContrato } from '../../contract/functions';

export const listaEmpresas = (companyType = null, offset = null, limit = null, isFilter = false, fantasy_name = null) => {
  const data = { limit, offset, isFilter, fantasy_name };

  if (companyType) {
    switch (companyType) {
      case 'matriz':
        data.id_tipo = 1;
        break;
      case 'filial':
        data.id_tipo = 2;
        break;
      default:
        break;
    }
  }

  return axios.get(`${urlEmpresas}`, { params: data })
};

export const verificarLimitesEmpresa = (filter = null) => axios.get(`${urlEmpresas}/verificarLimitesEmpresa`, { params: filter });

export async function listaEmpresasMatriz(filter = {}) {
  try {
    const res = await axios.get('/empresas/matriz', { params: filter });
    return (res.data.data);
  } catch (e) {
    return (e);
  }
}

export async function listaTiposEmpresas(filter = null) {
  return axios.get('/tipoEmpresa', { params: filter });
}

export function listaFiliais(idMatriz, filter = null) {
  return axios.get(`/empresas/filiais/${idMatriz}`, { params: filter });
}

export async function listaEmpresasHasStockModule() {
  return await axios.get('/empresas/moduloEstoque');
}

export async function checkMaxEmpresas(numTotalEmpresas, filters = null) {
  if (!numTotalEmpresas) return;

  try {
    const res = await getContrato(filters);
    const limit = res.data.data[0]["qtd_empresas"];
    return numTotalEmpresas >= limit;
  } catch (error) {
    console.error('Erro ao carregar contrato:', error);
    return false;
  }
}

export const generateIntegrationTokenEmpresa = (id) => axios.post(`${urlEmpresas}/gerarKey/${id}`)

export const validarSenha = (password) => axios.post(`${urlPessoas}/validarSenha`, { senha: password });
export const checkUserPassword = (id_pessoa, password) => axios.post(`${urlPessoas}/checkUserPassword`, { id_pessoa: id_pessoa, senha: password });

export const resetCredentials = (idEmpresa, matricula) => axios.post(`${urlPessoas}/reset`, { id_empresa: idEmpresa, matricula: matricula });